export default {
  "base": "tw:focus-visible:outline-primary",
  "variants": {
    "active": {
      "true": "tw:text-primary",
      "false": "tw:text-muted"
    },
    "disabled": {
      "true": "tw:cursor-not-allowed tw:opacity-75"
    }
  },
  "compoundVariants": [
    {
      "active": false,
      "disabled": false,
      "class": [
        "tw:hover:text-default",
        "tw:transition-colors"
      ]
    }
  ]
}